
import React from 'react';

const InputError = props => {
    
    const {
        id,
        errorMessage,
        isShown
    } = props;

    return (
        <>
        {isShown && 
            <div className="inputError-container" id={id}>
                <label className="error">
                    <span><em className='excl'>!</em>{errorMessage}</span>
                 </label>
            </div>	
        }
        </>
    );
};

export default InputError;
